import { REDUX_STORE } from '@funnels/constants';
import { ConveyancingActionTypes, ConveyancingReducerState, SharedActionTypes } from '@funnels/types';

const initialState: ConveyancingReducerState = {
  data: {},
  error: null,
  loading: 0,
};

export default function conveyancingReducer(
  state: ConveyancingReducerState = initialState,
  action: ConveyancingActionTypes | SharedActionTypes
): ConveyancingReducerState {
  switch (action.type) {
    case REDUX_STORE.SHARED_ACTION_TYPES.CLEAR_DATA:
    case REDUX_STORE.CONVEYANCING.ACTION_TYPES.CLEAR_CONVEYANCING_DATA:
      return {
        ...state,
        data: {},
      };
    case REDUX_STORE.SHARED_ACTION_TYPES.CLEAR_ERROR:
    case REDUX_STORE.CONVEYANCING.ACTION_TYPES.CLEAR_CONVEYANCING_ERROR:
      return {
        ...state,
        error: null,
      };
    case REDUX_STORE.CONVEYANCING.ACTION_TYPES.FETCH_CONVEYANCING:
      return {
        ...state,
        loading: state.loading + 1,
      };
    case REDUX_STORE.CONVEYANCING.ACTION_TYPES.FETCH_CONVEYANCING_SUCCESS:
      return {
        ...state,
        data: action.enquiries,
        loading: state.loading - 1,
      };
    case REDUX_STORE.CONVEYANCING.ACTION_TYPES.CREATE_CONVEYANCING_PROPERTY_ID:
      return {
        ...state,
        data: { property: { id: action.assetId }, intent: '' },
      };

    case REDUX_STORE.CONVEYANCING.ACTION_TYPES.CREATE_CONVEYANCING_INTENT:
      return {
        ...state,
        loading: state.loading + 1,
      };
    case REDUX_STORE.CONVEYANCING.ACTION_TYPES.CREATE_CONVEYANCING_INTENT_SUCCESS:
      return {
        ...state,
        data: {
          ...state.data,
          id: action.enquiryId,
        },
        loading: state.loading - 1,
      };
    case REDUX_STORE.CONVEYANCING.ACTION_TYPES.FETCH_CONVEYANCING_FAIL:
    case REDUX_STORE.CONVEYANCING.ACTION_TYPES.CREATE_CONVEYANCING_INTENT_FAIL:
      return {
        ...state,
        loading: state.loading - 1,
      };
    default:
      return state;
  }
}
